/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import { useApp } from "./..";
import { Gradient } from "./webGIRenderer";
import "./styles.scss";

// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'animated-gradient';

/**
 * This is the component description.
 */
const AnimatedGradient = ({
  className: userClassName
  // ...otherProps
}) => {
  const {
    userTheme
  } = useApp();
  const isClient = typeof window !== 'undefined';
  useEffect(() => {
    // Only initialize the Gradient if we're in the browser
    if (isClient) {
      const gradient = new Gradient();
      gradient.initGradient('#gradient-canvas');
    }
  }, [userTheme]);
  return /*#__PURE__*/React.createElement("canvas", {
    id: "gradient-canvas",
    "data-transition-in": true,
    className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' ')
    // {...otherProps}
  });
};
AnimatedGradient.propTypes = {
  /**
  * The HTML class names for this element
  */
  className: PropTypes.string
};
AnimatedGradient.defaultProps = {
  // primaryColor:'heading',
};
export default AnimatedGradient;